"use client"
import classNames from "classnames";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useState } from 'react';
import Ad from 'src/components/ads/Ad';
import Button from 'src/components/button/Button';
import TrailerOverlayWrapper from 'src/components/traileroverlaywrapper/TrailerOverlayWrapper';
import styles from "./TrailerPosterListExpander.module.css";

const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type TrailerPosterListExpanderProps = {
    children: React.ReactNode;
};
//#endregion

const trailerIdRegex = /#trailer(.+)/;

//#region [Component]
export default function TrailerPosterListExpander({ children }: TrailerPosterListExpanderProps) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [trailerId, setTrailerId] = useState<string | null>(null);
    const childArray = React.Children.toArray(children);
    const router = useRouter();
    const pathname = usePathname();

    useEffect(() => {
        const listener = (ev: HashChangeEvent) => {
            const match = trailerIdRegex.exec(ev.newURL);
            if ((match?.length ?? 0) >= 1) {
                setTrailerId(match![1]);
            }
        };

        window.addEventListener("hashchange", listener);
        // check if the already have a hash

        const match = trailerIdRegex.exec(window.location.hash);
        if ((match?.length ?? 0) >= 1) {
            // eslint-disable-next-line react-hooks/set-state-in-effect -- the URL hash is only known in the browser, so it is read after hydration
            setTrailerId(match![1]);
        }
        return () => {
            window.removeEventListener("hashchange", listener);
        }
    }, []);

    useEffect(() => {
        let currentTrailerId: null | string = null;
        const match = trailerIdRegex.exec(window.location.hash);
        if ((match?.length ?? 0) >= 1) {
            currentTrailerId = match![1];
        }
        if (trailerId !== null && trailerId !== currentTrailerId) {
            if (trailerId === "0") {
                router.replace(pathname!, { scroll: false });
            } else {
                router.replace(pathname! + "#trailer" + trailerId, { scroll: false });
            }
        }
    }, [pathname, router, trailerId]);

    return <>
        {childArray.slice(0, 18).map((child, idx) => <React.Fragment key={idx}>{child}</React.Fragment>)}
        <Ad className={classNames(styles.SAdRow, styles.STopAd)} targetId='FW_topp_trailerseksjon' />
        {!isExpanded && <Button className={styles.SButton} onClick={() => setIsExpanded(true)} text="Flere trailere" />}
        {isExpanded && <>
            <Ad className={classNames(styles.SAdRow, styles.SMidContentAd)} targetId='FW_midt3_trailerseksjon' />
            {childArray.slice(18).map((child, idx) => <React.Fragment key={`EX_${idx}`}>{child}</React.Fragment>)}
        </>}

        {trailerId && trailerId !== "0" && <TrailerOverlayWrapper videoId={trailerId!} onClose={() => setTrailerId("0")} onSelectTrailer={BRAND === "filmweb" ? (newTrailerId) => setTrailerId(newTrailerId.toString()) : undefined} />}
    </>;
}
//#endregion
